import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    background: linear-gradient(180deg, #596bf3 0%, #fff 68.27%);
    display: flex;
    width: 572px;
    max-height: 600px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Wrapper = styled.div``;

export const StyledImage = styled.img`
  height: 300px;
  align-self: stretch;
  border-radius: 8px;
`;

export const Footer = styled.div`
  display: flex;
  padding: 32px 40px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;
export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  align-self: stretch;
`;

export const Title = styled.span`
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;
export const SubTitle = styled.span`
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;
